import { request } from './request';

export function gdmDWExport(params: {
  owner_email: string;
  year: string;
}): Promise<{ download_url: string }> {
  let url = `/api/gdm_export/results/?owner_email=${params.owner_email}&year=${params.year}`;
  return request('GET', url, params);
}
